import React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink";
import { OverviewContainer, OverviewHighlightText, LearnMoreResources, TopicsContainer } from "./CommonViews";
export const CommonConfigurationServiceNowIntegrationOverview = () => {
    return (<OverviewContainer>
            <OverviewHighlightText>
                <p>
                    The <ExternalLink href="https://oc.to/ServiceNowIntegration">ServiceNow integration</ExternalLink> blocks deployments or runbooks until there's an approved change request. It links to existing requests or automatically creates new
                    ones, so you stay compliant without the manual work.
                </p>
            </OverviewHighlightText>
        </OverviewContainer>);
};
export const CommonConfigurationServiceNowIntegrationTopics = () => {
    return (<TopicsContainer>
            <LearnMoreResources>
                <div>
                    <ExternalLink href="https://oc.to/approvals">Approvals</ExternalLink>
                </div>
            </LearnMoreResources>
        </TopicsContainer>);
};
